'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuContent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('../Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function MenuContent(_ref) {
  var children = _ref.children,
      isLoading = _ref.isLoading;

  if (isLoading) {
    return _react2["default"].createElement(_Spinner2["default"], {
      assistiveText: 'loading menu',
      isVisible: true,
      size: 'small'
    });
  }

  return children;
}

MenuContent.propTypes = {
  className: _propTypes2["default"].string,
  style: _propTypes2["default"].object
};
MenuContent.defaultProps = {
  className: '',
  style: {}
};